<template>
  <main class="main main--register main--register-patient">

    <div class="gradient-bg" />

    <ui-auth
      title="Create Your VeriTooth Account"
      slug="registerPatient"
      copy="Create your account to request your dental records and get feedback on the work. Once your account is set up you can request your records from your dentist and get notified of reviews."
      submit="Create Account"
    >
      <div slot="top-link">
        <p class="small">Already have an account? <router-link :to="{ name: 'login' }">Log in</router-link> <br>Are you a dentist? <router-link :to="{ name: 'register-dentist' }">Register as a Dentist</router-link></p>
      </div>
      <div slot="before-submit">
        <p class="mt0 mb0 small">By signing up you agree to the VeriTooth</p>
        <p class="mt0 small"><router-link :to="{ name: 'terms' }" target="_blank">Terms &amp; Conditions</router-link> and <router-link :to="{ name: 'privacy' }" target="_blank">Privacy Policy</router-link></p>
      </div>
    </ui-auth>
  </main>
</template>

<script>
// Models
import meta from 'models/meta';

// Services
import { createMeta } from 'services/meta';

// Ui
import UiAuth from 'ui/Auth';

// Export
export default {
  name: `view-register`,

  // Meta data
  metaInfo: {
    title: meta.register.title,
    meta: createMeta(meta.register.meta),
  },

  // Components
  components: {
    UiAuth,
  },
};
</script>



// WEBPACK FOOTER //
// RegisterPatient.vue?05885574